import { render } from "./StatistiqueCaution.vue?vue&type=template&id=786e7966&ts=true"
import script from "./StatistiqueCaution.vue?vue&type=script&lang=ts"
export * from "./StatistiqueCaution.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__